import Background from './Background'
import Elements from './Elements'
import Text from './Text'
import Templates from './Templates'
import Search from './Search'
import Images from './Images'
import Illustrations from './Illustrations'
import Pixabay from './Pixabay'
import Uploads from './Uploads'
import Logo from './Logo'
import Signout from './SignOut'

class Icons {
  static Background = Background
  static Elements = Elements
  static Text = Text
  static Templates = Templates
  static Search = Search
  static Images = Images
  static Illustrations = Illustrations
  static Pixabay = Pixabay
  static Uploads = Uploads
  static Logo = Logo
  static Signout = Signout
}

export default Icons
